export const ActiveDayTypeValue = {
  Sunday: 'SUNDAY',
  Monday: 'MONDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY',
  Thursday: 'THURSDAY',
  Friday: 'FRIDAY',
  Saturday: 'SATURDAY',
} as const;

export type ActiveDayType = (typeof ActiveDayTypeValue)[keyof typeof ActiveDayTypeValue];

export type DayPart = {
  firstActiveHour: number;
  lastActiveHour: number;
  activeDayList: ActiveDayType[];
};

export const ALL_WEEK_DAYS: ActiveDayType[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];
